<ng-container *ngIf="myaccountYourCredentials$ | async as mycredentials">
  <!-- //{{ mycredentials | json }} -->
  <div class="myaccount-your-credentials">
    <div class="myaccount-credential-wrapper row">
      <div class="myaccount-credential-details col-lg-6 col-md-6 col-sm-6">
        <h2>{{ 'myAccount.credentialsTitle' | cxTranslate }}</h2>
        <div class="account-details">
          <div class="account-data">{{ mycredentials.firstName }}</div>
          <div class="account-data">{{ mycredentials.lastName }}</div>
          <div class="account-data">{{ 'myAccount.userName' | cxTranslate : { email: mycredentials.email } }}</div>
        </div>
      </div>
      <div *ngIf="isChangePasswordEnabled$ | async" class="myaccount-credential-link col-lg-6 col-md-6 col-sm-6">
        <a *ngIf="!this.isASMEnabled" [routerLink]="['/my-account/change-password']">{{
          'myAccount.changePassword' | cxTranslate
        }}</a>
        <div>{{ 'myAccount.keepSafeMessage' | cxTranslate }}</div>
      </div>
      <div class="myaccount-credential-account d-lg-none d-md-none col-sm-12">
        <div class="account-data">{{ mycredentials.firstName }}</div>
        <div class="account-data">{{ mycredentials.lastName }}</div>
        <div class="account-data">{{ 'myAccount.userName' | cxTranslate : { email: mycredentials.email } }}</div>
      </div>
      <div *ngIf="isChangePasswordEnabled$ | async" class="myaccount-credential-note d-lg-none d-md-none col-sm-12">
        {{ 'myAccount.keepSafeMessage' | cxTranslate }}
      </div>
    </div>
  </div>
</ng-container>
